import React, { Component } from "react";
import { IAppState, IAction } from '../../models/action/core';
import { IUserHomeMyCoursesProps } from '../../models/components/user-home_my_courses';
import * as Actions from '../../store/actions/userHome';
import { UserType } from '../../models/pages/login.d';
import { Dispatch } from 'redux';
import CourseHeader from '../../components/lesson/ShowAllCourses/CourseHeader';
import { connect } from 'react-redux';
import Loading from '../../components/loading/loading';
import CourseList from './courseList';
import { Log } from 'ng2-logger';
import Translator from '../../core/i18n';
import PastSessionsList from './pastSessionsList';
import imgAnn from '../../static/images/announcement.svg';
import moment from 'moment';
import ContentLoader from 'react-content-loader';


const T = Translator.create();
const _logger = Log.create('showAllCourses');
class CShowAllCourses extends Component<IUserHomeMyCoursesProps> {
    public state = {
        listItemCountIndex: 0,
        indexTerm:0,
        filters:{
            termId:0,
            programId: 0,
            status: -1,
            sourceCourseId: '',
            courseId:''
        },
        classesFilters: {
            take: 3,
            page: 1,
            total:0
        },
        termCourses: [],
        activeCourses: this.props.userHomeMyCourses && this.props.userHomeMyCourses.length > 0 ? this.findActiveCourses() : []
    };

    public componentDidMount = () => {
        const isTeacher = this.props.userType !== null && (this.props.userType === UserType.Teacher || this.props.userType === UserType.ProgramAdmin);
        this.props.dispatch(Actions.getUserHomeMyCourses(isTeacher,'getUserHomeMyCourses', 'get','',this.state.filters));
        this.setState({termCourses: this.props.userHomeMyCourses && this.props.userHomeMyCourses.length > 0 ?
            Object.keys(this.groupBy(this.findPastTerms(), 'termId')).map((key) => this.groupBy(this.findPastTerms(), 'termId')[key])
            : []})
    }


    componentDidUpdate(prevProps:any){
        if(prevProps.userHomeMyCourses &&
            this.props.userHomeMyCourses &&
            prevProps.userHomeMyCourses !== this.props.userHomeMyCourses){
                this.setState({
                    activeCourses: this.props.userHomeMyCourses && this.props.userHomeMyCourses.length > 0 ? this.findActiveCourses() : [],
                    termCourses: this.props.userHomeMyCourses && this.props.userHomeMyCourses.length > 0 ? Object.keys(this.groupBy(this.findPastTerms(), 'termId')).map((key) => this.groupBy(this.findPastTerms(), 'termId')[key]) : []
                }
            );
        }
    }

    dateCondition(endDate: any, startDate: any, termId: any) {
        const nowDate = moment().format('yyyy-MM-DDTHH:mm:ss');
        const firstDate = moment.utc("0001-01-01");
        return termId !== null && endDate && startDate && (moment.utc(startDate).isAfter(firstDate)) && (moment.utc(endDate).isAfter(firstDate)) ? (endDate.toString() >= nowDate) : true
    }

    findActiveCourses() {
        const isTeacher = this.props.userType && (this.props.userType === UserType.Teacher || this.props.userType === UserType.ProgramAdmin)
        if (this.props.userHomeMyCourses && this.props.userHomeMyCourses.length > 0) {
            const activeCourses = this.props.userHomeMyCourses.filter(item => item.activeStatus !== -1 && item.classId !== null &&
                (isTeacher ? (this.dateCondition(item.endDate, item.startDate, item.termId)) : (this.dateCondition(item.courseEndDate, item.courseStartDate, item.termId))))
            return activeCourses;
        }
    }

    findPastTerms(){
        const isTeacher = this.props.userType !== UserType.Student
        const nowDate = moment().format('yyyy-MM-DDTHH:mm:ss');
        if(this.props.userHomeMyCourses && this.props.userHomeMyCourses.length > 0){
            const terms = this.props.userHomeMyCourses.filter(item =>{
                const isDateRangeValid = isTeacher ? item.endDate && item.startDate && (item.endDate.toString() <= nowDate && item.startDate.toString() <= nowDate) : item.courseEndDate && item.courseStartDate && (item.courseEndDate.toString() <= nowDate && item.courseStartDate.toString() <= nowDate);
                return isDateRangeValid ?? item.termId !== null;
            });
            return terms;
        }
    }

    groupBy = (array:any, key:any) => {
        // Return the end result
            return array.reduce((result:any, currentValue:any) => {
            // If an array already present for key, push it to the array. Else create an array and push the object
            (result[currentValue[key]] = result[currentValue[key]] || []).push(
                currentValue
            );
            // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
            return result;
            }, {}); // empty object is the initial value for result object
        };

        shouldComponentUpdate(nextProps:any, nextState:any) {
            if (nextProps !== this.props) {
              return true;
            } else {
              return false;
            }
        }

    public render() {
        const myCoursesComponentSpacing = 60;
        return (
            <div style={{ backgroundColor: "#eeede9"}}>
                <div className="container pb-5">
                    <CourseHeader listItemCountIndex={this.props.userHomeMyCourses && this.props.userHomeMyCourses.length > 0} {...this.props} />
                        <div className="row">
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-12" style={{marginLeft: "-1em;"}}>
                                                {(this.props.userHomeMyCourses && this.props.userHomeMyCourses.length > 0) ?
                                                    (
                                                        <>
                                                        {/* <span className="font-w500">{T.t('r_active_courses')}</span> */}
                                                        <ul className="active_course_list">
                                                        <Loading spinnerId={'getUserHomeMyCourses'}>
                                                            <div style={{ backgroundColor: '#fbfaf6', height:'450px'}}>
                                                            <ContentLoader
                                                                speed={2}
                                                                backgroundColor="#f3f3f3"
                                                                foregroundColor="#ecebeb"
                                                                viewBox="0 0 730 400"
                                                                className="course_list_lazy_loader"
                                                            >
                                                                <rect x="68" y="18" rx="8" ry="8" width="68" height="3" />
                                                                <circle cx="35" cy="30" r="15" />
                                                                <rect x="68" y="30" rx="3" ry="8" width="100" height="6" />
                                                                <rect x="68" y="45" rx="3" ry="8" width="68" height="3" />
                                                                <circle cx="690" cy="25" r="8" />
                                                                <circle cx="670" cy="25" r="8" />
                                                                <circle cx="650" cy="25" r="8" />
                                                                <circle cx="630" cy="25" r="8" />
                                                                <circle cx="610" cy="25" r="8" />

                                                                <rect x="0" y={myCoursesComponentSpacing - 7} rx="3" ry={myCoursesComponentSpacing - 7 + 3} width="710" height="2" />

                                                                <rect x="68" y={18 + myCoursesComponentSpacing} rx="8" ry={8 + myCoursesComponentSpacing} width="68" height="3" />
                                                                <circle cx="35" cy={30 + myCoursesComponentSpacing} r="15" />
                                                                <rect x="68" y={30 + myCoursesComponentSpacing} rx="3" ry={8 + myCoursesComponentSpacing} width="100" height="6" />
                                                                <rect x="68" y={45 + myCoursesComponentSpacing} rx="3" ry={8 + myCoursesComponentSpacing} width="68" height="3" />
                                                                <circle cx="690" cy={25 + myCoursesComponentSpacing} r="8" />
                                                                <circle cx="670" cy={25 + myCoursesComponentSpacing} r="8" />
                                                                <circle cx="650" cy={25 + myCoursesComponentSpacing} r="8" />
                                                                <circle cx="630" cy={25 + myCoursesComponentSpacing} r="8" />
                                                                <circle cx="610" cy={25 + myCoursesComponentSpacing} r="8" />

                                                                <rect x="0" y={myCoursesComponentSpacing * 2 - 7} rx="3" ry={myCoursesComponentSpacing * 2 - 7 + 3} width="710" height="2" />

                                                                <rect x="68" y={18 + myCoursesComponentSpacing * 2} rx="8" ry={8 + myCoursesComponentSpacing * 2} width="68" height="3" />
                                                                <circle cx="35" cy={30 + myCoursesComponentSpacing * 2} r="15" />
                                                                <rect x="68" y={30 + myCoursesComponentSpacing * 2} rx="3" ry={8 + myCoursesComponentSpacing * 2} width="100" height="6" />
                                                                <rect x="68" y={45 + myCoursesComponentSpacing * 2} rx="3" ry={8 + myCoursesComponentSpacing * 2} width="68" height="3" />
                                                                <circle cx="690" cy={25 + myCoursesComponentSpacing * 2} r="8" />
                                                                <circle cx="670" cy={25 + myCoursesComponentSpacing * 2} r="8" />
                                                                <circle cx="650" cy={25 + myCoursesComponentSpacing * 2} r="8" />
                                                                <circle cx="630" cy={25 + myCoursesComponentSpacing * 2} r="8" />
                                                                <circle cx="610" cy={25 + myCoursesComponentSpacing * 2} r="8" />

                                                                <rect x="0" y={myCoursesComponentSpacing * 3 - 7} rx="3" ry={myCoursesComponentSpacing * 3 - 7 + 3} width="710" height="2" />

                                                                <rect x="68" y={18 + myCoursesComponentSpacing * 3} rx="8" ry={8 + myCoursesComponentSpacing * 3} width="68" height="3" />
                                                                <circle cx="35" cy={30 + myCoursesComponentSpacing * 3} r="15" />
                                                                <rect x="68" y={30 + myCoursesComponentSpacing * 3} rx="3" ry={8 + myCoursesComponentSpacing * 3} width="100" height="6" />
                                                                <rect x="68" y={45 + myCoursesComponentSpacing * 3} rx="3" ry={8 + myCoursesComponentSpacing * 3} width="68" height="3" />
                                                                <circle cx="690" cy={25 + myCoursesComponentSpacing * 3} r="8" />
                                                                <circle cx="670" cy={25 + myCoursesComponentSpacing * 3} r="8" />
                                                                <circle cx="650" cy={25 + myCoursesComponentSpacing * 3} r="8" />
                                                                <circle cx="630" cy={25 + myCoursesComponentSpacing * 3} r="8" />
                                                                <circle cx="610" cy={25 + myCoursesComponentSpacing * 3} r="8" />

                                                                <rect x="0" y={myCoursesComponentSpacing * 4 - 7} rx="3" ry={myCoursesComponentSpacing * 4 - 7 + 3} width="710" height="2" />

                                                                <rect x="68" y={18 + myCoursesComponentSpacing * 4} rx="8" ry={8 + myCoursesComponentSpacing * 4} width="68" height="3" />
                                                                <circle cx="35" cy={30 + myCoursesComponentSpacing * 4} r="15" />
                                                                <rect x="68" y={30 + myCoursesComponentSpacing * 4} rx="3" ry={8 + myCoursesComponentSpacing * 4} width="100" height="6" />
                                                                <rect x="68" y={45 + myCoursesComponentSpacing * 4} rx="3" ry={8 + myCoursesComponentSpacing * 4} width="68" height="3" />
                                                                <circle cx="690" cy={25 + myCoursesComponentSpacing * 4} r="8" />
                                                                <circle cx="670" cy={25 + myCoursesComponentSpacing * 4} r="8" />
                                                                <circle cx="650" cy={25 + myCoursesComponentSpacing * 4} r="8" />
                                                                <circle cx="630" cy={25 + myCoursesComponentSpacing * 4} r="8" />
                                                                <circle cx="610" cy={25 + myCoursesComponentSpacing * 4} r="8" />
                                                            </ContentLoader>
                                                            </div>
                                                        </Loading>
                                                            {
                                                                (this.state.activeCourses && this.state.activeCourses.length > 0) ?
                                                                    (
                                                                        <CourseList {...this.props}  listItemCountIndex={this.props.userHomeMyCourses && this.props.userHomeMyCourses.length > 0} />
                                                                    ) :
                                                                    (<>
                                                                        <img style={{ marginInlineStart: 'calc(50% - 89px)', marginTop: '2em' }} src={imgAnn} />
                                                                        <h5 id='unsearched' className='d-block' style={{ marginTop: 15, textAlign: 'center', marginBottom: 50 }}>
                                                                            {T.t('r_courses_not_found_criter')}
                                                                        </h5></>
                                                                    )
                                                            }
                                                        </ul>
                                                        </>
                                                    ) : (
                                                    (<>
                                                        <img style={{ marginInlineStart: 'calc(50% - 89px)', marginTop: '2em' }} src={imgAnn} />
                                                        <h5 id='unsearched' className='d-block' style={{ marginTop: 15, textAlign: 'center', marginBottom: 50 }}>
                                                            {
                                                                T.t('r_courses_not_found_criter')
                                                            }
                                                        </h5>
                                                    </>)
                                                )}
                                            </div>
                                        </div>
                            </div>
                            <div className="col-md-12 mt-5 ">
                                <ul className="passed_course_list">
                                {
                                    (this.state.termCourses && this.state.termCourses.length > 0) ?
                                        (
                                            <PastSessionsList {...this.props} listItemCountIndex={this.state.indexTerm} />
                                    ) :''
                                }
                                </ul>
                            </div>
                        </div>
                </div>
            </div>
        );
    }
}



const mapStateToProps = (state: IAppState, ownProps: IUserHomeMyCoursesProps): IUserHomeMyCoursesProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IUserHomeMyCoursesProps = Object.assign({}, ownProps, {
        userHomeMyCourses: state.userHomePage.userHomeMyCourses,
        useHomeMyCoursesIsLoading: state.userHomePage.useHomeMyCoursesIsLoading,
        userType: state.login.identitiy.userType
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        // next.userHomePage.useHomeMyCoursesIsLoading === prev.userHomePage.useHomeMyCoursesIsLoading
        next.userHomePage.userHomeMyCourses === prev.userHomePage.userHomeMyCourses
    );
    return ret;
};
const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return ({
        dispatch
    });
};


const ShowAllCourses = connect(
    mapStateToProps,
    dispatchProps,
    null, {
    areStatesEqual
}
)(CShowAllCourses);

export default ShowAllCourses;
